import { createStore as _createStore, Store } from 'vuex';

import agencyProfile from '@/store/agencyProfile/AgencyProfileStore';
import app from '@/store/app/AppStore';
import chatRelay from '@/store/chatRelay/ChatRelayStore';
import districtCatalog from '@/store/districtCatalog/DistrictCatalogStore';
import featuredPlacements from '@/store/featuredPlacements/FeaturedPlacementsStore';
import funnelApi from '@/store/funnel/FunnelApiStore';
import insertion from '@/store/insertion/InsertionStore';
import insertions from '@/store/insertions/InsertionsStore';
import leadStore from '@/store/leads/LeadStore';
import referenceListings from '@/store/referenceListings/ReferenceListingsStore';
import sellerLeadsStore from '@/store/sellerLeads/SellerLeadsStore';
import seon from '@/store/seon/SeonStore';
import toplisting from '@/store/toplisting/ToplistingStore';
import winningMandate from '@/store/winningMandate/WinningMandateStore';
import { SplitVuexModule } from '@smg-real-estate/vue-experiments';

export function createStore(): Store<any> {
  return _createStore({
    modules: {
      agencyProfile,
      districtCatalog,
      insertion,
      insertions,
      leadStore,
      toplisting,
      funnelApi,
      sellerLeadsStore,
      app,
      chatRelay,
      referenceListings,
      featuredPlacements,
      split: SplitVuexModule,
      seon,
      winningMandate,
    },
  });
}

export default createStore();
